import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BarChart = createReactComponent("BarChart", ["svg", defaultAttributes, [["line", {
  x1: "12",
  y1: "20",
  x2: "12",
  y2: "10",
  key: "b64o6r"
}], ["line", {
  x1: "18",
  y1: "20",
  x2: "18",
  y2: "4",
  key: "51ffxi"
}], ["line", {
  x1: "6",
  y1: "20",
  x2: "6",
  y2: "16",
  key: "4eimgl"
}]]]);
export default BarChart;